// extracted by mini-css-extract-plugin
export default {"upiP2PQr":"UpiP2PQr_upiP2PQr__RgZLL","qr":"UpiP2PQr_qr__RFPf2","subtitle":"UpiP2PQr_subtitle__2oSFR","line":"UpiP2PQr_line__z-Rku","text":"UpiP2PQr_text__vZuQU"};